import React, {
  useState, useEffect, useMemo, forwardRef,
} from 'react';

import { SearchIcon } from '@vlabs/icons';
import { Control } from '@vlabs/uikit';
import debounce from 'lodash/debounce';

import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';

import { useUserListFilters } from '../useUserListPageFilters';
import st from './popovers.module.sass';
import { useGetDepartments } from '@vlabs/api/artemy/client';

function DepartmentFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const [searchInputValue, setSearchInputValue] = useState<string>();
  const { filters, updateFilters } = useUserListFilters();
  const { data } = useGetDepartments({ page_size: 15, name: searchInputValue });
  const departmentOptions = data?.departments?.map((r) => ({
    label: r.name ?? r.department_id,
    value: r.department_id,
  }));

  const debouncedSetDepartment = useMemo(() => debounce((value: string) => {
    setSearchInputValue(value);
  }, 1000), []);

  useEffect(() => {
    return () => {
      debouncedSetDepartment.cancel();
    };
  }, [debouncedSetDepartment]);

  return (
    <PopoverWithButton
      {...props}
      onClickReset={() => updateFilters({ department_id: undefined })}
      ref={ref}
    >
      <div className={st.Options}>
        <Control.Input
          icon={<SearchIcon />}
          onChange={(e) => debouncedSetDepartment(e.target.value)}
        />
        <div className={st.RadioWrapper}>
          {departmentOptions?.map((option) => {
            return (
              <Control.Radio
                checked={filters.department_id === option.value}
                key={option.value}
                label={option.label}
                onChange={() => updateFilters({ department_id: option.value })}
              />
            );
          })}
        </div>
        <div className={st.Divider} />
      </div>
    </PopoverWithButton>
  );
}

const DepartmentFilterPopoverWithRef = forwardRef(DepartmentFilterPopover);
export { DepartmentFilterPopoverWithRef as DepartmentFilterPopover };
